import { Anchor, Flex, Image, Space } from "@mantine/core";
import IconAppleStore from "../assets/applestore.svg";
import IconPlayStore from "../assets/playstore.svg";
const CopyRight = () => {
  return (
    <Flex
      // direction={{ base: "column", sm: "row" }}
      className="box-copyright"
      justify={"space-between"}
      align={"center"}
      h={"100%"}
    >
      <Flex className="box-download" align={"center"}>
        <Flex className="box-btn">
          <Anchor
            href="https://apps.apple.com/us/app/manta-classic/id6471317092"
            target="_blank"
            variant="transparent"
          >
            <Image src={IconAppleStore} w={"120"} />
          </Anchor>
          <Space w={10} />
          <Anchor
            href="https://play.google.com/store/apps/details?id=com.Ritolabs.MantaClassic"
            target="_blank"
            variant="transparent"
          >
            <Image src={IconPlayStore} w={"120"} />
          </Anchor>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default CopyRight;
